import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-takedown',
  templateUrl: './takedown.component.html',
  styleUrls: ['./takedown.component.css']
})
export class TakedownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
